import $ from "jquery";

export const vacancy = () => {
  const elms = {
    vacancyFilter: "#vacancy-filter", 
  };

  function stickyVacancy() {
    const filterTop = $(elms.vacancyFilter).offset().top;

    function checkPosition() {
      let windowY = $(window).scrollTop();
      if (windowY >= filterTop) {
        // Scrolling UP
        $(elms.vacancyFilter).addClass("is-sticky");
      } else {
        $(elms.vacancyFilter).removeClass("is-sticky");
      }
    }

    window.addEventListener('scroll', checkPosition);
  }

  if ($(elms.vacancyFilter).length) {

    stickyVacancy();

  }
};
 